import React, { Component } from 'react';
import { connect } from 'react-redux';
import { insertDataMasterOnSessionStorage } from '../../utils/verifier.utils.js';
import {
  fetchPutVerifierConfig,
  fetchVerifierConfig
} from '../../login/api.actions';
import Tab from 'react-bootstrap/lib/Tab';
import Tabs from 'react-bootstrap/lib/Tabs';
import GeneralTab from './GeneralTab';
import  VenuesTab  from './VenuesTab';
import { Overlay, SearchBar } from 'clorian-frontend-components';
import { equalForKeys } from '../../utils/verifier.utils';
import ErrorAlert from '../structure/ErrorAlert';
import moment from 'moment';
import {FormattedMessage,injectIntl} from "react-intl"



const STATUS = {
  DISABLED: "disabled",
  ENABLE: "enabled",
}

class Configuration extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentConfiguration: '',
      loading: true,
      showAlert: false,
      searchValue: '',
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleAllInputChange = this.handleAllInputChange.bind(this);
    this.handleDate = this.handleDate.bind(this);
    this.handleSaveNewConfiguration = this.handleSaveNewConfiguration.bind(this);
    this.handleCloseErrorValidation = this.handleCloseErrorValidation.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const verifier = JSON.parse(sessionStorage.getItem('verifier'));
    const configFromSessionStorage = sessionStorage.getItem(
      'currentConfiguration'
    );

    if (
      configFromSessionStorage === null ||
      configFromSessionStorage === 'undefined'
    ) {
      dispatch(fetchVerifierConfig(verifier.verifierId)).then(
        ({ response }) => {
          insertDataMasterOnSessionStorage(
            'currentConfiguration',
            response,
            true
          );
        }
      );
    }

    setTimeout(() => {
      this.setState({
        currentConfiguration: JSON.parse(
          sessionStorage.getItem('currentConfiguration')
        ),
        loading: false
      });
    }, 1000);
  }

  handleCloseErrorValidation(e) {
    this.setState({ showErrorAlert: false });
  }

  handleInputChange(event, id, idName) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    const config = this.state.currentConfiguration;

    if (id && idName) {
      let arrayToSave = [];
      let object = { [idName]: id };

      if (value) {
        config[name].push(object);
      } else {
        config[name]
          .filter(item => !equalForKeys(item, object))
          .map(item => arrayToSave.push(item));

        config[name] = arrayToSave;
      }
    } else {
      config[name] = value;
    }

    this.setState({
      [name]: value,
      currentConfiguration: config
    });
  }

  handleAllInputChange(event, venues, idName) {
    const { name, checked } = event.target;
    const { searchValue } = this.state;

    this.setState(prevState => {
      const config = { ...prevState.currentConfiguration };

      const filteredItems = venues.filter(venue =>
          venue.name.toLowerCase().includes(searchValue.toLowerCase())
      );
      const newSelectedItems = filteredItems.map(venue => ({ [idName]: venue[idName] }));

      const allSelected = newSelectedItems.every(newItem =>
          config[name].some(existingItem => equalForKeys(existingItem, newItem))
      );

      if (allSelected) {
        config[name] = config[name].filter(
            existingItem => !newSelectedItems.some(newItem => equalForKeys(existingItem, newItem))
        );
      } else {
        config[name] = [...new Set([...config[name], ...newSelectedItems])];
      }

      return {
        [name]: checked,
        currentConfiguration: config
      };
    });
  }

  handleDate(date) {
    const config = this.state.currentConfiguration;
    if (!moment.isMoment(date)) {
      date = moment(date);
    }
    config['fixedDate'] = date.format('YYYY-MM-DD HH:mm:ss');

    this.setState({
      currentConfiguration: config
    });
  }

  handleSaveNewConfiguration() {
    const { dispatch } = this.props;
    const verifier = JSON.parse(sessionStorage.getItem('verifier'));

    this.setState({
      loading: true
    });

    dispatch(
      fetchPutVerifierConfig(
        this.state.currentConfiguration,
        verifier.verifierId
      )
    )
      .then(({ response }) => {
        if (response) {
          sessionStorage.setItem(
            'currentConfiguration',
            JSON.stringify(this.state.currentConfiguration)
          );
          this.setState({
            showAlert: true,
            alert: 'success',
            message: 'Operación realizada con éxito'
          });
        } else {
          this.setState({
            showAlert: true,
            alert: 'danger',
            message: 'Operación fallida'
          });
        }

        this.setState({
          loading: false
        });
      })
      .catch(function() {
        console.log('some errors here at fetchPutVerifierConfig');
      });
  }

  handleSearchChange (e){
    this.setState({searchValue: e.target.value});
  };

  render() {
    const {intl} = this.props;
    const { currentConfiguration, loading, showAlert, searchValue } = this.state;
    const venues = JSON.parse(sessionStorage.getItem('venuecapacities')).filter((item => item.status === STATUS.ENABLE));
    const extras = JSON.parse(sessionStorage.getItem('extras')).filter((item => item.status === STATUS.ENABLE));
    const accesses = JSON.parse(sessionStorage.getItem('accesses')).filter((item => item.status === STATUS.ENABLE));

    //todo cambiar a cuando se selecciona y existe el buscar del filtro no borrar lo anterior
    const rolesFromSessionStorage = JSON.parse(sessionStorage.getItem('roles'));
    const hasPermission = rolesFromSessionStorage.includes(
      'ROLE_VERIFIER_CONFIG_WRITE'
    );

    const placeholderLabel = intl.formatMessage({ id: 'venue.placeholder', defaultMessage: 'Search...' });

    return (
      <div className="row verifier">
        <Overlay loading={loading} />

        <div className="col-md-12 configuration">
          {showAlert && (
            <ErrorAlert
              closeError={() => this.handleCloseErrorValidation}
              error={this.state}
            />
          )}

          <h1><FormattedMessage defaultMessage="Configuration" id="menu.settings"/></h1>
          {currentConfiguration && (
              <Tabs defaultActiveKey={1} id="uncontrolled-tab">
                <Tab eventKey={1} key="1" title={intl.formatMessage({id: 'config.tab.general'})}>
                  <GeneralTab
                      currentConfiguration={currentConfiguration}
                      handleInputChange={this.handleInputChange}
                      handleDate={this.handleDate}
                      hasPermission={hasPermission}
                  />
                </Tab>

                <div className="container mt-5" style={{marginTop: "20px"}}>
                  <SearchBar
                      placeholder={placeholderLabel}
                      onChange={this.handleSearchChange}
                  />
                </div>

                <Tab eventKey={2} key="2" title={intl.formatMessage({id: 'config.tab.privileges'})}>
                  <VenuesTab
                      venues={venues}
                      extras={extras}
                      access={accesses}
                      searchValue={searchValue}
                      hasPermission={hasPermission}
                      currentConfiguration={currentConfiguration}
                      handleInputChange={this.handleInputChange}
                      handleAllInputChange={this.handleAllInputChange}
                  />
                </Tab>
              </Tabs>
          )}

          {hasPermission && (
              <button
                  type="button"
                  className="btn btn-validate btn-xs-block"
                  onClick={this.handleSaveNewConfiguration}
                  disabled={loading}
              >
                <FormattedMessage defaultMessage="Save" id="config.save"/>
            </button>
          )}
        </div>
      </div>
    );
  }
}

export default connect()(injectIntl(Configuration));
